import { render, staticRenderFns } from "./SireList.vue?vue&type=template&id=182f2b90"
import script from "./SireList.vue?vue&type=script&lang=js"
export * from "./SireList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports